<template>
  <div id="app" class="login">
    <div class="logo">
      <img class="logo-url" :src="logoUrl" />
      <h2>{{ systemName }}</h2>
    </div>
    <div class="language" @mouseover="languageStatus = true" @mouseout="languageStatus = false">
      <div class="dropMenu">
        LANGUAGE
        <span class="el-icon-caret-bottom"></span>
      </div>
      <div v-show="languageStatus">
        <div>
          <div
            class="item"
            :class="current === index ? 'on' : ''"
            v-for="(item, index) in languageType"
            :key="index"
            @click="chooseLanguage(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="box-reveal">
        <img :src="require('./assets/bg-left.png')" class="floorplan" alt="" />
      </div>
      <div class="box-left" v-if="isUpdatePass">
        <h2>{{ lang.welcome }}</h2>
        <div class="form">
          <div class="form-item">
            <label class="user-name-label">
              <img :src="userNameUrl" alt />
            </label>
            <input v-model="username" :placeholder="lang.username" auto-complete="new-password" @keyup.enter="submit()" />
          </div>

          <div class="form-item">
            <label class="pass-word-label">
              <img :src="passwordUrl" alt />
            </label>
            <input v-model="password" type="password" :placeholder="lang.password" auto-complete="new-password" @keyup.enter="submit()" />
          </div>

          <div class="text-agreement">
            <el-checkbox v-model="agreementChecked"></el-checkbox>
            <p class="text-agreement-info">
              <span style="margin-left: 1rem">{{ lang.readAgree }}</span>
              <span class="agreement" @click="handleAgreement">{{ lang.privacyPolicyAgreement }}</span>
            </p>
          </div>

          <div class="form-item" v-if="showCaptcha">
            <label>
              <img :src="captchaUrl" alt />
            </label>
            <input v-model="captcha" @keyup.enter="submit()" :placeholder="lang.captcha" />
          </div>

          <div class="form-yzm" v-if="showCaptcha">
            <VeirfyConf ref="verify" :langtype="langtype" @tokenTransfer="tokenTransfer"></VeirfyConf>
          </div>

          <div class="form-item" :class="showCaptcha ? '' : 'submit-item'">
            <el-button :loading="loading" @click="submit" :disabled="!agreementChecked" class="submit">
              {{ lang.login }}
            </el-button>
          </div>
        </div>
      </div>
      <UpdatePassword v-if="!isUpdatePass" :lang-type="langtype" @backLogin="backLogin"></UpdatePassword>
    </div>
    <div class="footer">Version 3.0 ©2014-2023 SenseTime. All Rights Reserved</div>

    <el-dialog class="login-dialog" :visible.sync="centerDialogVisible" width="61.6rem" center>
      <p slot="title" class="b-title">{{ lang.agreement }}</p>
      <div class="content">
        <p>{{ lang.contentPage1 }}</p>
        <p>{{ lang.contentPage2 }}</p>
        <p>{{ lang.contentPage3 }}</p>
        <p>{{ lang.contentPage4 }}</p>
        <p>{{ lang.contentPage5 }}</p>
        <p>{{ lang.contentPage6 }}</p>
        <p>{{ lang.contentPage7 }}</p>
        <p>{{ lang.contentPage8 }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleReadAgree">{{ lang.readAndAgree }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VeirfyConf from './components/verify-conf.vue';
import UpdatePassword from './components/update-password.vue';
import axios from 'axios';
import { getBossConfig, checkFirstLogin } from '@blade-sxp/login/api/index.ts';
import { LoginModule } from '@blade/common/store/login';
import { EventBus, EventKeys } from '@blade/common';
import DrawLines from './utils/drawLines';

const langTypeMap = {
  zh: 'zh-CN',
  en: 'en-US',
  ja: 'ja-JP',
};
const zh = {
  username: '用户名',
  password: '密码',
  captcha: '验证码',
  login: '登录',
  forget: '忘记密码？',
  inputUsername: '请填写用户名',
  inputPassword: '请填写密码',
  inputCaptcha: '请输入验证码',
  errorMsg: '用户或密码错误',
  rememberPassword: '记住密码',
  explain: '按住滑块，拖动到最右边',
  errorCaptcha: '验证码错误',
  errorSystem: '系统异常',
  welcome: '欢迎登录',
  languageType: [
    {
      name: '中文',
      label: 'zh',
    },
    {
      name: '英文',
      label: 'en',
    },
    {
      name: '日本語',
      value: 'ja',
    },
  ],
  readAgree: '我已阅读并同意',
  privacyPolicyAgreement: '《隐私政策协议》',
  agreement: '隐私政策协议',
  contentPage1:
    '请您认真阅读以下说明并充分理解，如您同意，请点击“我已阅读并同意隐私政策协议”并继续使用，如您不同意，系统将直接退出，谢谢。',
  contentPage2: '根据相关法律、行政法规要求，任何组织、个人收集数据，应当采取合法、正当的方式，不得窃取或者以其他非法方式获取数据。',
  contentPage3: '法律、行政法规对收集、使用数据的目的、范国有规定的，应当在法律、行政法规规定的目的和范围内收集、使用数据。',
  contentPage4:
    '国家机关为履行法定职责的需要收集、使用数据，应当在其履行法定职责的范围内依照法律、行政法规规定的条件和程序进行；对在履行职责中知悉的个人隐私、个人信息、商业秘密、保密商务信息等数据应当依法予以保密，不得泄露或者非法向他人提供。',
  contentPage5: '法律、行政法规规定提供数据处理相关服务应当取得行政许可的，服务提供者应当依法取得许可。',
  contentPage6:
    '开展数据处理活动，应当遵守法律、法规，尊重社会公德和伦理，遵守商业道德和职业道德，诚实守信，履行数据安全保护义务，承担社会责任，不得危害国家安全、公共利益，不得损害个人、组织的合法权益。',
  contentPage7:
    '未经授权的使用、复制、截屏以及传播系统内部信息（包括但不限于身份证号、手机号、人脸照片、身份信息等），造成信息泄露的行为都是禁止的。',
  contentPage8:
    '请充分保管您的账号及密码，由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露或系统信息泄露的风险及后果，均由您自行承担。',
  readAndAgree: '我已阅读并同意隐私政策协议',
};
const en = {
  username: 'Account Name',
  password: 'Password',
  captcha: 'Captcha',
  login: 'Sign in',
  forget: 'Forgot Password?',
  inputUsername: 'Please input the account name',
  inputPassword: 'Please input the password',
  inputCaptcha: 'Please enter verification code',
  errorMsg: 'Account name or password error',
  rememberPassword: 'Remember password',
  explain: 'Slide to right',
  errorCaptcha: 'Captcha Error',
  errorSystem: 'System Error',
  welcome: 'Welcome',
  languageType: [
    {
      name: 'Chinese',
      label: 'zh',
    },
    {
      name: 'English',
      label: 'en',
    },
    {
      name: '日本語',
      value: 'ja',
    },
  ],
  readAgree: 'I have read and agree to',
  privacyPolicyAgreement: '"Privacy Policy Agreement"',
  agreement: 'Privacy Policy Agreement',
  contentPage1:
    'Please read the following instructions carefully and fully understand. If you agree, please click "I have read and agree to the Privacy Policy Agreement" and continue to use it. If you do not agree, the system will exit directly, thank you.',
  contentPage2:
    'According to the related laws and administrative regulations, any organization or individual shall collect data in a legal and proper way, and shall not steal or obtain data in other illegal ways.',
  contentPage3:
    'If laws and administrative regulations stipulate the purpose and scope of data collection and use, the data shall be collected and used within the purpose and scope stipulated by laws and administrative regulations.',
  contentPage4:
    'The collection and use of data by state organs for the performance of their statutory duties shall be carried out within the scope of their statutory duties in accordance with the conditions and procedures prescribed by laws and administrative regulations; personal privacy, personal information, business secrets, confidential business information and other data shall be kept confidential in accordance with the law, and shall not be leaked or illegally provided to others.',
  contentPage5:
    'Where laws and administrative regulations stipulate that an administrative license shall be obtained for the provision of services related to data processing, the service provider shall obtain a license in accordance with the law.',
  contentPage6:
    'Data processing activities should abide by laws and regulations, respect social morality and ethics, abide by business ethics and professional ethics, be honest and trustworthy, perform data security protection obligations, assume social responsibilities, and must not endanger national security, public interests, or harm individuals or organizations. legitimate interests.',
  contentPage7:
    'Unauthorized use, copying, screenshots, and dissemination of internal system information (including but not limited to ID numbers, mobile phone numbers, face photos, identity information, etc.), resulting in information leakage are prohibited.',
  contentPage8:
    'Please take good care of your account number and password. Since you inform others of your user password or share your registered account with others, you shall bear the risks and consequences of any personal data leakage or system information leakage resulting therefrom.',
  readAndAgree: 'I have read and agree',
};

const ja = {
  username: 'ユーザー名',
  password: 'パスワード',
  captcha: '認証コード',
  login: 'ログイン',
  forget: 'パスワードを忘れた?',
  inputUsername: 'ユーザー名を入力してください',
  inputPassword: 'パスワードを入力してください',
  inputCaptcha: '認証コードを入力してください',
  errorMsg: 'ユーザーまたはパスワードが正しくありません',
  rememberPassword: 'パスワードを保存',
  explain: 'スライダーを押したまま右端までドラッグします',
  errorCaptcha: 'キャプチャは無効です',
  errorSystem: 'システムエラー',
  languageType: [
    {
      name: '中文',
      label: 'zh',
    },
    {
      name: '英文',
      label: 'en',
    },
    {
      name: '日本語',
      value: 'ja',
    },
  ],
  agreement: 'Privacy Policy Agreement',
  content: '',
  readAndAgree: '',
};

export default {
  name: 'App',
  components: {
    VeirfyConf,
    UpdatePassword,
  },
  data() {
    return {
      loading: false,
      username: '',
      password: '',
      captcha: '',
      token: '',
      showImage: false,
      // captcha access status
      status: 'FAIL',
      langtype: 'en',
      lang: en,
      current: 0,
      type: 'default',
      languageStatus: false,
      showCaptcha: this.checkCaptchaSession(),
      remberPassword: false,
      userNameUrl: require('./assets/user-name.svg'),
      passwordUrl: require('./assets/pass-word.svg'),
      explain: '',
      providers: [],
      captchaUrl: require('./assets/catpcha.png'),
      logoUrl: require('./assets/logo-url.png'),
      languageType: [
        {
          name: 'English',
          label: 'en',
        },
        {
          name: '中文',
          label: 'zh',
        },
        // {
        //   name: '日本語',
        //   value: 'ja'
        // },
      ],
      agreementChecked: false,
      centerDialogVisible: false,
      systemName: 'SenseXperience',
      userId: '',
      drawLines: null,
    };
  },
  computed: {
    isUpdatePass() {
      return LoginModule.isUpdatePass;
    },
  },
  mounted() {
    this.init();
    this.drawLines = new DrawLines();
    this.autoScale();
    window.addEventListener('resize', this.autoScale);
    // console.log(document.cookie);
    // this.mm();
    // Cookies.set('name', 111);
    // this.showCaptcha = true;
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.autoScale);
    this.drawLines.destroy();
  },
  methods: {
    autoScale() {
      const Width = 1920;
      let Scale = 1;
      Scale = window.innerWidth / Width;
      document.getElementsByTagName('html')[0]?.setAttribute('style', `font-size: ${10 * Number(Scale.toFixed(4))}px;`);
      this.drawLines.setCanvasSize();
    },
    backLogin() {
      window.sessionStorage.setItem('isAuthenticated', 'false');
      localStorage.removeItem('language');
      LoginModule.updatePermission([]);
      let backlen = history.length - 1;
      history.go(-backlen);
      window.location.href = '/logout';
      LoginModule.updatePassType(true);
      EventBus.$emit(EventKeys.Logout);
      // const redirectUrl = `${window.location.protocol}//${window.location.host}/authn`;
      // window.location.replace(redirectUrl);
      // location.reload();
    },
    init() {
      getBossConfig().then((res) => {
        if (res.language && res.language !== '') {
          if (res.language === 'ENGLISH') {
            this.langtype = 'en';
            this.lang = en;
          } else if (res.language === 'CHINESE') {
            this.langtype = 'zh';
            this.lang = zh;
          }
        }
        if ((res.systemName && res.systemName !== '') || (res.defaultLogoUrl && res.defaultLogoUrl !== '')) {
          this.systemName = res.systemName;
          this.logoUrl = res.defaultLogoUrl;
        }
      });
    },
    isFirstLogin(url) {
      const params = {
        username: this.username,
      };
      checkFirstLogin(params).then((res) => {
        if (res.checkFirstLogin) {
          this.isUpdatePass = false;
          this.userId = res.userId;
        } else {
          window.location = url;
        }
      });
    },

    handleAgreement() {
      this.centerDialogVisible = true;
    },
    handleReadAgree() {
      this.centerDialogVisible = false;
      this.agreementChecked = true;
    },

    checkCaptchaSession() {
      let cookies = document.cookie.split(';');
      // console.log("cookies====" + cookies);
      for (let i = 0; i < cookies.length; i++) {
        if (cookies[i].split('=')[0].trim() === 'captcha') {
          return true;
        }
      }
      return false;
    },
    // mm() {
    //   if (navigator.language) {
    //     var language = navigator.language;
    //   } else {
    //     var language = navigator.browserLanguage;
    //   }
    //   console.log(language);
    //   return language;
    // },
    chooseLanguage(item, index) {
      this.current = index;
      if (index === 0) {
        this.lang = en;
        this.langtype = 'en';
        localStorage.setItem('language', 'en-us');
      } else if (index === 2) {
        this.lang = ja;
        this.langtype = 'ja';
      } else {
        this.lang = zh;
        this.langtype = 'zh';
        localStorage.setItem('language', 'zh');
      }
      this.languageStatus = false;
    },
    tokenTransfer(value, status) {
      this.token = value;
      this.status = status;
    },
    showlist() {
      this.languageStatus = !this.languageStatus;
    },
    getProviders() {
      let challenge = '';
      const params = window.location.search.slice(1).split('&');
      for (let i = 0; i < params.length; i++) {
        let tmp = params[i].split('=');
        if (tmp[0] === 'login_challenge') {
          challenge = decodeURIComponent(tmp[1]);
          localStorage.setItem('challenge', challenge);
        }
      }
      if (!challenge) {
        challenge = localStorage.getItem('challenge');
      }

      axios.get('/iam/api/v1/auth/providers').then((response) => {
        if (response.status === 200 && response.data) {
          this.providers = response.data.map((d) => ({
            ...d,
            auth_url: d.auth_url + '@' + challenge,
          }));
        }
      });
    },
    submit() {
      if (this.agreementChecked) {
        // console.log('document.cookie==', document.cookie);
        if (!this.username.trim()) {
          return this.$elmessage.error(this.lang.inputUsername);
        }
        if (!this.password.trim()) {
          return this.$elmessage.error(this.lang.inputPassword);
        }
        if (this.checkCaptchaSession() && !this.captcha.trim()) {
          return this.$elmessage.error(this.lang.inputCaptcha);
        }
        const params = window.location.search.slice(1).split('&');
        let challenge = '';
        for (let i = 0; i < params.length; i++) {
          let tmp = params[i].split('=');
          if (tmp[0] === 'login_challenge') {
            challenge = decodeURIComponent(tmp[1]);
            localStorage.setItem('challenge', challenge);
          }
        }
        if (!challenge) {
          challenge = localStorage.getItem('challenge');
        }
        this.loading = true;

        // 这里的链接指向
        const url = '/iam/iam/api/v1/auth/login';
        const userName = this.username?.toLowerCase();
        axios
          .post(
            url,
            'account=' +
              encodeURIComponent(userName) +
              '&password=' +
              encodeURIComponent(this.password) +
              '&captcha=' +
              encodeURIComponent(this.captcha) +
              '&token=' +
              encodeURIComponent(this.token) +
              '&challenge=' +
              encodeURIComponent(challenge) +
              (this.type === 'ad' ? '&credential_type=ad' : ''),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept-Language': langTypeMap[this.langtype] || 'en',
              },
            }
          )
          .then((response) => {
            this.loading = false;
            if (response.status === 200) {
              // this.isFirstLogin(response.data.redirect_url);
              window.location = response.data.redirect_url;
              console.log(response.data.redirect_url);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.showCaptcha = this.checkCaptchaSession();
            this.$refs.verify && this.$refs.verify.refreshIt();

            const data = error.response.data;
            if (data.details) {
              this.$elmessage.error(data.details[0]?.message);
              // if (data.code === 401) {
              //   this.$elmessage.error(this.lang.errorMsg);
              // } else if (data.code === 403) {
              //   this.$elmessage.error(this.lang.errorCaptcha);
              // } else if (data.code >= 500) {
              //   this.$elmessage.error(this.lang.errorSystem);
              // }
            }
            // console.log(error.response);
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
html,
body {
  margin: 0;
  height: 100%;
}
body,
input {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif, system-ui;
}
#app {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background: $login-background;
  position: relative;
}
.logo {
  position: absolute;
  top: 3rem;
  left: 3.2rem;
  display: flex;
  align-items: center;
  z-index: 1;
  h2 {
    font-size: 4rem;
    color: $esc-color;
    margin-left: 3.2rem;
    padding-left: 2rem;
    position: relative;
  }
  h2::before {
    content: '';
    width: 0.2rem;
    height: 3.3rem;
    background-color: $esc-color;
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translate(0%, -50%);
  }

  .logo-url {
    width: auto;
    max-height: 47px;
  }
}
.language {
  position: absolute;
  top: 2.4rem;
  right: 4rem;
  z-index: 100;
}
.dropMenu {
  color: $white;
  font-size: 1.6rem;
  margin-bottom: 0.8rem;
  cursor: pointer;
}
.language .item {
  line-height: 3rem;
  font-size: 1.4rem;
  color: $white;
  cursor: pointer;
  width: 9.6rem;
  line-height: 3.2rem;
  box-sizing: border-box;
  padding-left: 1.2rem;
  background-color: $light-blue-bg-9;
}
.language .item.on {
  color: $grey-fill-10;
  background-color: $white;
  line-height: 3.6rem;
}

.box {
  width: 132.4rem;
  // width: 52.6rem;
  height: 59.6rem;
  // min-height: 59.6rem;
  // position: relative;
  position: absolute;
  margin: auto;
  margin-right: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  // background: #0e1625;
  border-radius: 1.6rem;
  z-index: 99;
}
.box .box-reveal {
  width: calc(132.4rem - 52.6rem);
}
.box .box-reveal .floorplan {
  width: 100%;
  height: 100%;
}
.box .box-left {
  width: 52.6rem;
  padding: 6.4rem 7.4rem;
  background: $white;
  border-top-right-radius: 1.6rem;
  // border-radius: 1.6rem;
  border-bottom-right-radius: 1.6rem;
  .logo-url {
    display: block;
    margin: 0 auto;
    height: 6rem;
  }
}
.box h2 {
  margin-top: 1.2rem;
  margin-bottom: 6rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 600;
  font-size: 6.4rem;
  line-height: 6rem;
  color: $black;
  text-align: center;
}
.form {
  margin: auto;
}
.form-item {
  overflow: hidden;
  margin-bottom: 1.6rem;
  position: relative;
  border-radius: 0.2rem;
  height: 4rem;
}
.form .submit-item {
  margin-top: 4.8rem;
}
.form .show-captcha-submit-item {
  margin-top: 1.6rem;
}
.text-agreement {
  margin-bottom: 1.6rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2rem;
  color: $gray-text-0;
  // white-space: nowrap;
  span {
    white-space: nowrap;
  }
}
.text-agreement .el-checkbox__label {
  color: $gray-text-0;
}
.text-agreement .agreement {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2rem;
  color: $color-primary;
  cursor: pointer;
}
.text-agreement .text-agreement-info {
  width: 100%;
}

.form-yzm {
  width: 357px;
  margin-bottom: 1.6rem;
  position: relative;
  border-radius: 0.2rem;
}
.form-item label {
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
  width: 4.4rem;
  height: 4rem;
  padding: 1rem;
  line-height: 4rem;
  font-size: 1.2rem;
  font-weight: 400;
  color: $gray-text-17;
  position: relative;
  z-index: 1;
  background-color: transparent;
  img {
    width: 100%;
    height: 100%;
  }
}
.form-item {
  .user-name-label,
  .pass-word-label {
    color: unset;
    i {
      opacity: 0.7;
    }
  }
}
.form-item input {
  width: 100%;
  height: 4rem;
  position: absolute;
  left: 0;
  top: 0;
  background-color: $white;
  border: none;
  outline: none;
  color: $gray-text-17;
  border: 0.1rem solid $border;
  padding-left: 4.4rem;
  transition: border-bottom-color 0.4s;
  border-radius: 0.3rem;
}
.form-item input:focus {
  border-color: $login-input-focus;
}
.form-item button {
  width: 100%;
  height: 4rem;
  background: $color-primary;
  border-radius: 0.2rem;
  font-size: 1.6rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
  color: $gray-text-0;
  cursor: pointer;
  outline: none;
  transition: filter 0.4s;
  border: none !important;
}
.form-item button:hover {
  background: $color-primary-600;
  color: $gray-text-0;
}
.form-item button:focus {
  background: $button-text-primary;
  color: $gray-text-0;
}
button.el-button.is-disabled:disabled {
  color: $button-text;
}

.forget {
  text-decoration: none;
  margin-bottom: 1.2rem;
  margin-top: 0.8rem;
  float: right;
  font-size: 1.2rem;
  font-weight: 400;
  color: $light-blue-bg-10;
  line-height: 1.4rem;
}
.radio {
  text-align: right;
  margin-bottom: 1.6rem;
}
.el-radio {
  margin-right: 1.5rem;
}
.el-radio__label {
  /* font-size: 12px; */
  color: $white;
  padding-left: 0.5rem;
}
/* // .el-radio__inner {
//   width: 12px;
//   height: 12px;
// }
// .el-radio__input.is-checked + .el-radio__label {
//   color: #6387ff;
// }
// .el-radio__input.is-checked .el-radio__inner {
//   border-color: #6387ff;
//   background: #6387ff;
// } */
.remberPassword {
  margin-bottom: 1.5rem;
}
.el-checkbox__label {
  /* // font-size: 12px; */
  color: $white;
}
/* // .el-checkbox__inner {
//   width: 12px;
//   height: 12px;
//   line-height: 12px;
// }
// .el-checkbox__input.is-focus .el-checkbox__inner {
//   color: #6387ff;
// }
// .el-checkbox__input.is-checked .el-checkbox__inner {
//   border-color: #6387ff;
//   background: #6387ff;
// }
// .el-checkbox__input.is-checked + .el-checkbox__label {
//   color: #6387ff;
// } */
.footer {
  position: absolute;
  bottom: 10px;
  min-width: 600px;
  width: 100%;
  height: 20px;
  text-align: center;
  line-height: 2rem;
  font-size: 1.4rem;
  color: $white;
}
.login-dialog {
  background-color: $alert-details-face;
  .b-title {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: $gray-text-0;
  }
  /deep/.el-dialog__header {
    padding-top: 2.4rem;
    padding-bottom: 0;
  }
  /deep/.el-dialog__body {
    padding: 1.4rem 2.4rem;
  }
  /deep/.el-dialog__footer {
    padding-top: 0.8rem;
    padding-bottom: 2.4rem;
  }
  .content {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2.2rem;
    color: $gray-text-0;
  }
}
</style>
